// Vendor imports
const _ = require('lodash')
// Shared imports
const nameUtils = require('shared/name-utils')
// Client lib imports
const { send: ajax } = require('client/lib/request')
const businessEvents = require('client/lib/business-events')

async function extractArticleFromUrl(url) {
  const result = await ajax({
    url: '/api/v0.1/extract',
    method: 'post',
    data: { url }
  })
  const article = _.pick(result, [
    'md5image', 'image', 'hostname',
    'url', 'url_id', 'hash', 'count'
  ])
  return {
    ...article,
    title: result.title || result.url,
    submittedUrl: result['original_url'],
    timestamp: Date.now()
  }
}

async function fetchCollections(urlId) {
  const result = await ajax({
    url: '/api/v0.1/mixes/all',
    method: 'post',
    data: { 'url_id': urlId }
  })
  return [
    result.initial,
    ...result.recommended,
    ...result.existing
  ]
}

async function createCollection({ name, recommended = false }) {
  const cleanName = nameUtils.cleanName(name).trim()
  if (!nameUtils.isValidMixName(cleanName)) {
    throw new Error('Invalid collection name')
  }
  const result = await ajax({
    url: '/api/v0.1/mixes',
    method: 'post',
    data: {
      name: cleanName,
      description: '',
      recommended
    }
  })
  await businessEvents.trackSegment('create-mix', {
    name: result.name,
    'mix_id': result.id
  })
  return result
}

async function addToCollection(urlId, collectionId) {
  const result = await ajax({
    url: `/api/v0.1/mix/url/${collectionId}`,
    method: 'post',
    data: { 'url_id': urlId }
  })
  await businessEvents.trackSegment('add-url-to-mix', {
    mixId: collectionId,
    'url_id': urlId
  })
  return result
}

async function removeFromCollection(urlId, collectionId) {
  const result = await ajax({
    url: `/api/v0.1/mix/url/${collectionId}`,
    method: 'delete',
    data: { 'url_id': urlId }
  })
  await businessEvents.trackSegment('remove-url-from-mix', {
    mixId: collectionId,
    'url_id': urlId
  })
  return result
}

async function addToMixedCollection(urlId) {
  const result = await ajax({
    url: `/api/v0.1/mix/url/mixed`,
    method: 'post',
    data: { 'url_id': urlId }
  })
  await businessEvents.trackSegment('add-url-to-mix', {
    mixId: result.mixId,
    'url_id': urlId
  })
  return result
}

async function removeFromMixedCollection(urlId) {
  const result = await ajax({
    url: `/api/v0.1/mix/url/mixed`,
    method: 'delete',
    data: { 'url_id': urlId }
  })
  await businessEvents.trackSegment('remove-url-from-mix', {
    mixId: result.mixId,
    'url_id': urlId
  })
  return result
}

module.exports = {
  extractArticleFromUrl,
  fetchCollections,
  createCollection,
  addToCollection,
  addToMixedCollection,
  removeFromCollection,
  removeFromMixedCollection
}
